import React, { useEffect, useState } from 'react'
import MenuIcon from '@mui/icons-material/Menu'

import { Box, IconButton, Popover, Tab, Tabs, Theme, Typography, useMediaQuery, useTheme } from '@mui/material'
import { AppSetting, MenuItem } from '../../screens/App/App'
import { useSelector } from 'react-redux'
import { getNavPoint } from '../../store/settings/settings.selectors'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'

interface Props {
  items: AppSetting[]
  selectedTab?: AppSetting
  changeTab: (tab: MenuItem) => void
}

const NavBar: React.FC<Props> = (props: Props) => {
  const navPoint = useSelector(getNavPoint)
  const theme: Theme = useTheme()
  const downLg = useMediaQuery(theme.breakpoints.down('lg'))

  const [tab, setTab] = useState<AppSetting | undefined>(props.selectedTab)

  useEffect(() => {
    setTab(props.selectedTab)
  }, [props.selectedTab],
  )

  useEffect(() => {
    const selectedTab = navPoint[0]
    setTab(props.items.find(tab => tab.value === selectedTab))
  }, [navPoint],
  )

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null)
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }
  const open = Boolean(anchorEl)

  return (
    <>
      {downLg ? (
        <>
          <IconButton
            sx={{
              position: 'absolute',
              display: 'flex',
              top: 8,
              right: '60px',
              padding: '20px',
              color: '#fff',
            }} onClick={handleClick}
          >
            <MenuIcon />
          </IconButton>
          <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
          >
            {props.items && props.items.map((item, index) =>
              <Box
                key={index}
                sx={{
                  padding: '5px 20px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  props.changeTab(item.value as MenuItem)
                  handleClose()
                }}
              >
                <Typography variant='body1' sx={{ color: theme.palette.primary.main }}>
                  {item.title}
                </Typography>
                <ArrowForwardIosIcon
                  sx={{ width: '15px', height: '15px', color: theme.palette.primary.main, marginLeft: '10px' }}
                />
              </Box>,
            )}
          </Popover>
        </>
      )
        : (
          <Tabs
            sx={{
              position: 'absolute',
              display: 'flex',
              top: 0,
              right: 50,
              padding: '20px',
            }}
            value={tab?.value || props.items[0].value}
            onChange={(e, newValue) => {
              props.changeTab(newValue)
            }}
          >
            {props.items && props.items.map((item, index) =>
              <Tab
                sx={{
                  fontWeight: 'bold',
                  fontSize: '14px',
                  color: '#fff',
                }}
                key={index}
                value={item.value}
                label={item.title}
              />)}
          </Tabs>)}
    </>
  )
}

export default NavBar
